<template>
  <v-dialog v-model="showPopup" persistent max-width="650">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Set Quantity Alert
        <span v-if="item.name !== ''" class="ml-2">
          for <b>"{{ item.name }}"</b>
        </span>
      </v-card-title>
      <v-card-text class="d-flex justify-center text-h6 font-weight-bold pb-2">
        <span style="color: #514f6b">Alert when quantity is:</span>
      </v-card-text>
      <v-card-text class="d-flex no-wrap justify-center mb-4">
        <v-select
          class="mr-4"
          :items="alertsOptions"
          style="max-width: 175px"
          v-model="alertType"
          dense
          hide-details
        />
        <v-text-field
          outlined
          dense
          type="number"
          min="0"
          style="max-width: 75px"
          hide-details
          v-model="alertQuantity"
        />
      </v-card-text>
      <v-card-text class="d-flex justify-center text-h6 font-weight-bold pb-0">
        <span style="color: #514f6b">This alert will be sent to:</span>
      </v-card-text>
      <v-card-text
        class="d-flex justify-center"
      >
        <v-select
          placeholder="Select people manually"
          dense
          multiple
          style="max-width: 260px"
          :items="filteredInvitedUsers"
          item-value="id"
          v-model="alertSelectedPeoples"
        >
          <template v-slot:prepend-item>
            <v-text-field
              dense
              :v-ripple="false"
              outlined
              placeholder="Search"
              class="mx-4"
              v-model="searchUser"
            />
          </template>
        </v-select>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="hide"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirmAddAlert"
          depressed
          class="save-btn small-size"
          :disabled="!valid"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  MODULE_POPUP,
  SET_ADD_EDIT_ALERT_POPUP_SHOW,
  SET_PENDING_ALERT_TO_SAVE,
  SET_DELETE_ALERT_POPUP_SHOW
} from '@/store/constant/mutation-types'
import service from '@/services/alerts'
export default {
  name: 'AddEditAlertPopup',
  props: ['item'],
  data() {
    return {
      alertsOptions: [
        { value: 'GREATER_THEN', text: 'Greater than' },
        { value: 'GREATER_THEN_OR_EQUAL', text: 'Greater than or equal' },
        { value: 'LESS_THEN', text: 'Less than' },
        { value: 'LESS_THEN_OR_EQUAL', text: 'Less than or equal' }
      ],
      alertType: 'LESS_THEN',
      alertQuantity: 1,
      alertSelectedPeoples: [],
      itemId: '',
      searchUser: ''
    }
  },
  watch: {
    isEdit(v) {
      if (v) {
        this.buildAlertToEdit()
      }
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'getIsOwner']),
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    ...mapGetters('popup', ['alertPendingToSave']),
    isEdit() {
      return !!this.item?.alert?.id
    },
    tmpUsers() {
      return this.getActiveWarehouse?.info.users
    },
    currentAlert() {
      return this.alertPendingToSave
    },
    valid() {
      if (this.alertSelectedPeoples.length) return true
      else return false
    },
    showPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showAddEditAlertPopup`]
    },
    filteredInvitedUsers() {
      if (this.tmpUsers?.length) {
        const result = list => {
          return list.reduce((arr, current) => {
            if (current.inviteStatus !== 'invited') {
              current.text = current.firstName + ' ' + current.lastName
              arr.push(current)
            }
            return arr
          }, [])
        }
        if (this.searchUser.length) {
          return result(this.tmpUsers.filter((el) => {
            const name = el.firstName + ' ' + el.lastName
            return name.toLowerCase().includes(this.searchUser.toLowerCase())
          }))
        } else {
          return result(this.tmpUsers)
        }
      } else return []
    }
  },
  methods: {
    ...mapActions('alerts', ['addAlert', 'updateAlert']),
    deleteAlert() {
      this.hide()
      this.$store.commit(`${MODULE_POPUP}/${SET_DELETE_ALERT_POPUP_SHOW}`, true)
    },
    hide() {
      this.buildAlertToEdit()
      this.$store.commit(
        `${MODULE_POPUP}/${SET_ADD_EDIT_ALERT_POPUP_SHOW}`,
        false
      )
    },
    async confirmAddAlert() {
      const payload = {
        type: this.alertType,
        value: parseInt(this.alertQuantity),
        users: this.alertSelectedPeoples,
        archived: this.alertPendingToSave
          ? this.alertPendingToSave.archived
          : true
      }

      if (this.itemId) {
        payload.itemId = this.itemId
        const response = this.isEdit
          ? await service.updateAlert(payload)
          : await service.addAlert(payload)
        if (response?.data?.error?.type === 200) {
          this.$emit('saveAlert', response.data.data.alert)
          this.$store.commit(
            `${MODULE_POPUP}/${SET_PENDING_ALERT_TO_SAVE}`,
            payload
          )
        }
      }

      this.hide()
    },
    buildAlertToEdit() {
      if (this.isEdit) {
        const alert = this.item.alert
        this.alertType = alert.type
        this.alertSelectedPeoples = alert.users || []
        this.alertQuantity = alert.value
        this.id = alert.id
      }
    }
  },
  created() {
    if (!this.getIsOwner) this.sendAlertToMembers = true
    this.itemId = parseInt(this.$route.params.id)
    if (this.isEdit) {
      this.buildAlertToEdit()
    }
  }
}
</script>

<style scoped>
.delete-alert-btn {
  margin: 30px auto auto;
  display: block;
  text-align: center;
}
.cursor-point {
  cursor: pointer;
}
</style>
